var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w-full"},[_c('div',{staticClass:"lg:mx-auto xl:max-w-6xl xl:mx-auto w-full"},[_c('Navigation'),_vm._v(" "),_c('Hero')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }